import { gql } from 'graphql-request'

export const ResponsiveImage = gql`
  fragment responsiveImageFragment on ResponsiveImage {
    srcSet
    sizes
    src
    width
    height
    aspectRatio
    alt
    title
    bgColor
    base64
  }
`
